module.exports = __webpack_public_path__ + "static/04-399b200b7b03d6371e710fdee4c95078.jpg";